import React from 'react';
import { Col, Row, Input, FormGroup } from 'reactstrap';
import CollapsibleCard from 'components/CollapsibleCard';

interface Props {
  changeFilter: (key: string, value: unknown) => void;
  currentOptions: { validated?: string };
}

function Filters({ changeFilter, currentOptions }: Props) {
  return (
    <CollapsibleCard title="Filtros">
      <Row>
        <Col sm={4}>
          <FormGroup>
            <label>Validado</label>
            <Input
              type="select"
              onChange={event => changeFilter('validated', event.target.value)}
              value={currentOptions?.validated ?? 'all'}
            >
              <option value="all">Todos</option>
              <option value="true">Sí</option>
              <option value="false">No</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </CollapsibleCard>
  );
}

export default Filters;
